import {
  Button,
  Container,
  Fab,
  makeStyles,
  Modal,
  Snackbar,
  TextField,
  Tooltip,
} from "@material-ui/core";
import { useNavigate } from "react-router-dom";
import Files from "react-files";
import { Add as AddIcon } from "@material-ui/icons";
import React, { useEffect, useState } from "react";
import MuiAlert from "@material-ui/lab/Alert";
import { useDispatch, useSelector } from "react-redux";
import { getAllSubFamilies } from "../reduxSaga/actions";

import { updateCategoryData } from "../reduxSaga/actions";
import ProductService from "../services/ProductService";
import getCurrentUserId from "../reduxSaga/sagas/requests/currentUserId";

const useStyles = makeStyles((theme) => ({
  fab: {
    position: "fixed",
    bottom: 20,
    right: 20,
  },
  familyContainer: {
    marginBottom: theme.spacing(3),
    marginTop: theme.spacing(3),
    display: "flex",
    justifyContent: "space-between",
  },

  container: {
    borderRadius: 10,
    boxShadow: "0 3px 5px 2px rgba(18,131,255,0.87)",
    width: 500,
    height: 300,
    backgroundColor: "white",
    position: "absolute",
    top: -30,
    bottom: 0,
    left: 0,
    right: 0,
    margin: "auto",
    [theme.breakpoints.down("sm")]: {
      width: "100vw",
      height: "100vh",
    },
  },
  form: {
    padding: theme.spacing(2),
  },
  item: {
    marginBottom: theme.spacing(3),
    marginTop: theme.spacing(3),
  },

  cancelAndAddButtom: {
    marginBottom: theme.spacing(3),
    marginTop: theme.spacing(5),
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },

  input: {
    "&::placeholder": {
      fontStyle: "italic",
    },
  },
}));

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const EditCategory = ({ setOnEditCategory, oldCategoryData }) => {
  const dispatch = useDispatch();
  const CategoryNotification = useSelector(
    (state) => state.staff.CategoryNotification
  );
  const availableSubFamilies = useSelector(
    (state) => state.staff.availableSubFamilies
  );

  const classes = useStyles();
  const [open, setOpen] = useState(true);
  const [openAlert, setOpenAlert] = useState(false);
  const [openErrorAlert, setOpenErrorAlert] = useState(false);
  const [errorAlertText, setErrorAlertText] = useState();
  const [oldFamilyIndex, setOldFamilyIndex] = useState(0);
  const [SubFamilyValue, setSubFamilyValue] = useState(0);
  const [familyValue, setFamilyValue] = useState(0);

  const [name, setName] = useState();
  const [desc, setDesc] = useState();
  let navigate = useNavigate();

  useEffect(() => {
    //dispatch(getAllFamilies(0));
    dispatch(getAllSubFamilies(1));
  }, []);

  useEffect(() => {
    availableSubFamilies &&
      availableSubFamilies.map((element, i) => {
        if (element.id === oldCategoryData.productSubFamilyId) {
          setOldFamilyIndex(i);
          setFamilyValue(oldCategoryData.productFamilyName);
          console.log(oldCategoryData.productFamilyName);
        }
      });
    setName(oldCategoryData.name);
    setDesc(oldCategoryData.description);
  }, [availableSubFamilies]);

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenAlert(false);
  };

  const handleEroorClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenErrorAlert(false);
  };

  const onChangeName = (event) => {
    setName(event.target.value);
  };

  const onChangeDesc = (event) => {
    setDesc(event.target.value);
  };

  const onCancelButtonHandler = () => {
    setOpen(false);
    setOnEditCategory(false);
  };

  const onAddFamilyHandler = () => {
    navigate(`/families`);
  };

  const onAddCategory = () => {
    if (name == null) {
      setOpenErrorAlert(true);
      setErrorAlertText("Erreur :le champ du nom est vide ! ");
    } else {
      let updateCategoryModel = {
        idCategory: oldCategoryData.idCategory,
        newName: name,
        newDescription: desc,
        idUserCreation: 0,
      };
      ProductService.updateCategory(
        getCurrentUserId(),
        oldCategoryData.idCategory,
        name,
        desc
      )
        .then((response) => {
          setOpenAlert(true);

          setOnEditCategory(false);
          setOpen(false);
          window.location.reload(false);
        })
        .catch((e) => {
          console.log("error", e);
        });

      // dispatch(updateCategoryData(updateCategoryModel));
    }
  };

  return (
    <>
      <div
        className="modal fade show"
        id="edit-category"
        style={{ display: "block", background: "#00000066" }}
      >
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header bg-black">
              <h4 class="modal-title">Modifier la catégorie</h4>
            </div>
            <div class="modal-body">
              <div className="row">
                <div className="col-sm-12">
                  <div className="form-group">
                    <label htmlFor="inputName">Libellé</label>
                    <input
                      defaultValue={name}
                      onChange={onChangeName}
                      type="text"
                      id="inputName"
                      className="form-control"
                    />
                  </div>
                </div>
              </div>

              <div className="row">
                <div className="form-group col-sm-12">
                  <label htmlFor="inputDescription">Description</label>
                  <textarea
                    placeholder="Saisir..."
                    onChange={onChangeDesc}
                    id="inputDescription"
                    className="form-control"
                    rows={2}
                    defaultValue={desc}
                  />
                </div>
              </div>
            </div>
            <div class="modal-footer justify-content-between">
              <button
                type="button"
                onClick={onCancelButtonHandler}
                class="btn btn-light"
                data-dismiss="modal"
              >
                Close
              </button>

              <button
                type="button"
                onClick={onAddCategory}
                class="btn btn-light"
              >
                Confirmer
              </button>
            </div>
          </div>
        </div>
      </div>
      {/* <Modal open={open}>
        <Container className={classes.container}>
          <form className={classes.form} autoComplete="off">
            <div className={classes.item}>
              <TextField
                required
                id="standard-basic"
                label=" Taper le nouveau nom "
                defaultValue={oldCategoryData.name}
                variant="outlined"
                size="small"
                style={{ width: "100%" }}
                onChange={onChangeName}
                InputProps={{
                  classes: { input: classes.input },
                }}
              />
            </div>

            <div className={classes.item}>
              <TextField
                id="outlined-multiline-static"
                multiline
                rows={4}
                InputProps={{
                  classes: { input: classes.input },
                }}
                defaultValue={oldCategoryData.description}
                variant="outlined"
                label="Taper la nouvelle description"
                size="small"
                style={{ width: "100%" }}
                onChange={onChangeDesc}
              />
            </div>

            <div className={classes.cancelAndAddButtom}>
              <Button
                variant="outlined"
                color="primary"
                style={{ marginRight: 20 }}
                onClick={onAddCategory}
              >
                Valider
              </Button>
              <Button
                variant="outlined"
                color="secondary"
                onClick={onCancelButtonHandler}
              >
                Cancel
              </Button>
            </div>
          </form>
        </Container>
      </Modal> */}
      <Snackbar
        open={openAlert}
        autoHideDuration={4000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert onClose={handleClose} severity="success">
          Ajout avec success !
        </Alert>
      </Snackbar>

      <Snackbar
        open={openErrorAlert}
        autoHideDuration={4000}
        onClose={handleEroorClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert onClose={handleEroorClose} severity="error">
          {errorAlertText}
        </Alert>
      </Snackbar>
    </>
  );
};

export default EditCategory;
